import React from 'react';
import UbiAgreeBottomSheet, {UbiAgreeBottomSheetProps} from '@di-shared/features/ubi/UbiAgreeBottomSheet';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 350;

function UbiAgreeBottomSheetPage() {
  const {vin, serviceId, termsData, agreeInfo, companyName} = (window as any).data as UbiAgreeBottomSheetProps;

  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <UbiAgreeBottomSheet
        vin={vin}
        serviceId={serviceId}
        termsData={termsData}
        agreeInfo={agreeInfo}
        companyName={companyName}
      />
    </BottomSheetWebViewWrapper>
  );
}

export default UbiAgreeBottomSheetPage;
